import { format } from 'date-fns';

export function formatDate(datetime: string): string {
  const date = new Date(datetime);
  return format(date, 'MMMM d, yyyy');
}
